<template>
  <v-col
    v-if="mustShowInstallmentOptions"
    cols="12"
  >
    <v-subheader class="pa-0">
      <span class="title">Parcelamento</span>
    </v-subheader>
    <v-card
      width="100%"
    >
      <v-row
        align="center"
        class="ma-0 px-4"
      >
        <v-skeleton-loader
          v-if="isLoadingInstallments"
          :loading="isLoadingInstallments"
          type="article"
          width="100%"
        />
        <v-fade-transition>
          <v-col
            v-if="!isLoadingInstallments"
            cols="6"
          >
            <v-select
              v-model="installmentsObject"
              label="Parcelas"
              :items="creditCardInstallments"
              return-object
              @change="onInstallmentsSelectChange"
              outlined
              no-data-text="Insira os dados do cartão de crédito para visualizar o número de parcelas disponível"
            >
              <template v-slot:selection="{ item }">
                {{item | installmentsDisplay}}
              </template>
              <template v-slot:item="{ item }">
                {{item | installmentsDisplay}}
              </template>
            </v-select>
          </v-col>
        </v-fade-transition>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
  import {isEmpty, isEqual, isNull, isUndefined} from "lodash/lang"
  import {debounce} from "lodash/function"
  import {getInstallmentsOptions} from "../../api/api-billing"
  import {PAYMENT_METHOD} from "../../helpers/payment/constants"

  const _PaymentMixin = Symbol.for("_PaymentMixin")
  const SetResumeInstallmentsInfo = Symbol.for("SetResumeInstallmentsInfo")

  export default {
    name: "InstallmentsInfo",
    inject: {_PaymentMixin, SetResumeInstallmentsInfo},
    model: {
      prop: "model",
      event: "change"
    },
    props: {
      strCcBrand: {
        type: String,
        validator: prop => typeof prop === "string" || prop === null || prop === undefined,
      }
    },
    data: () => ({
      isLoadingInstallments: false,
      installmentsObject: null,
      creditCardInstallments: []
    }),
    methods: {
      handlerInstallmentsOptions: debounce(function (strCcBrand) {
        let maxInstallments = this.PaymentMixin.shoppingCart["int_max_installments"]
        this.isLoadingInstallments = true
        const installmentsData = {
          str_cc_brand: strCcBrand,
          str_country: "BR",
          str_currency: "BRL"
        }
        getInstallmentsOptions(this.$apiAuth.getAuthToken(), installmentsData)
          .then((res) => {
            const installmentsOptions = res.data.data
            let maxInstallmentsOption = installmentsOptions[res.data.data.length - 1]
            if (maxInstallmentsOption["quantity"] > maxInstallments)
              this.creditCardInstallments = installmentsOptions.slice(0, maxInstallments)
            else
              this.creditCardInstallments = installmentsOptions
            this.installmentsObject = installmentsOptions[0]
          })
          .finally(() => {
            this.isLoadingInstallments = false
          })
      }),
      onInstallmentsSelectChange(value) {
        this.SetResumeInstallmentsInfo(value)
        this.$emit("change", value["quantity"])
      }
    },
    filters: {
      installmentsDisplay(installment) {
        let strFee = ''
        if (installment["interestFree"])
          strFee = 'Sem juros'
        else
          strFee = 'Com juros'
        return `${installment["quantity"]} x R$ ${installment["installmentAmount"]} - ${strFee}`
      }
    },
    computed: {
      PaymentMixin() {
        return this._PaymentMixin()
      },
      mustShowInstallmentOptions() {
        if (!this.PaymentMixin.paymentMethod) return false
        if (isEqual(this.PaymentMixin.paymentMethod, PAYMENT_METHOD.POST_PAY)) return false
        if (this.isLoadingInstallments) return true
        return true
      },
    },
    watch: {
      strCcBrand(newValue) {
        this.installmentsObject = null
        this.$emit("change", 1)
        this.creditCardInstallments = []
        if (!newValue) return
        if (isEmpty(newValue) || isNull(newValue) || isUndefined(newValue)) return
        if (newValue === "") return
        this.handlerInstallmentsOptions(newValue)
      }
    }
  }
</script>

<style scoped>

</style>
